import { createAction } from '@reduxjs/toolkit';

import type { RootState } from 'state/store';

export const getInitialSlice = (slices, initialStates) =>
  slices.reduce((acc, curr) => {
    acc[curr] = initialStates[curr];
    return acc;
  }, {});

export const resetSlices = createAction<string[]>('resetState/resetSlices');
export const restoreState = createAction<{ store: RootState }>(
  'resetState/restoreState'
);
export const resetStateToInitial = createAction('resetState/resetToInitial');
